import apiClient from './apiClient';
import { DataPurgePolicy, UpdateDataPurgePolicyRequest } from '../types/DataPurgePolicy';

export const dataPurgeApi = {
  /**
   * Hent alle purge-policyer (WMS_DataPurgePolicy).
   */
  getPolicies: async (): Promise<DataPurgePolicy[]> => {
    const response = await apiClient.get<DataPurgePolicy[]>('/api/datapurge/policies');
    return response.data;
  },

  /**
   * Oppdater en eksisterende purge-policy. PolicyKey endres ikke.
   */
  updatePolicy: async (policyKey: string, request: UpdateDataPurgePolicyRequest): Promise<DataPurgePolicy> => {
    const response = await apiClient.put<DataPurgePolicy>(
      `/api/datapurge/policies/${encodeURIComponent(policyKey)}`,
      request
    );
    return response.data;
  }
};

export default dataPurgeApi;
